const tabsInit = (tabs: HTMLElement) => {
  const allTabs = tabs.querySelectorAll('.content-tabs__title') as NodeListOf<HTMLElement>;
  const allContent = tabs.querySelectorAll('.content-tabs__content') as NodeListOf<HTMLElement>;

  const setActiveTab = (id: string) => {
    const newContent = tabs.querySelector(`.content-tabs__content[data-id="${id}"]`) as HTMLElement;
    const newTitle = tabs.querySelector(`.content-tabs__title[data-id="${id}"]`) as HTMLElement;

    allTabs.forEach((tab) => tab.classList.remove('content-tabs__title--active'));
    allContent.forEach((content) => content.classList.remove('content-tabs__content--active'));
    newContent.classList.add('content-tabs__content--active');
    newTitle.classList.add('content-tabs__title--active');
  };

  [...allTabs].forEach((tab) => {
    tab.addEventListener('click', () => {
      const { id } = tab.dataset;
      setActiveTab(id);
    });
  });
};

export default tabsInit;
